import React from 'react'

export const Loading = () => {
    return (
        <div className="flex items-center justify-center h-[75vh] p-5 bg-gray-100 dark:bg-blue-cole-dark-surface min-w-screen">

            <div className="flex space-x-2 animate-pulse">
                <div className="w-3 h-3 bg-blue-cole rounded-full"></div>
                <div className="w-3 h-3 bg-blue-cole rounded-full"></div>
                <div className="w-3 h-3 bg-blue-cole rounded-full"></div>
            </div>

        </div>
    )
}
